<template>
    <v-card elevation="8" class="ma-5 mt-10" style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
        <v-container fluid>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md12 ma-4>
                    <h2><strong>Relatório de Animais Gerenciados</strong></h2>
                </v-flex>
            </v-layout>

            <v-form ref="form">
                <v-layout row wrap justify-start class="pl-2">
                    <v-flex class="item" lg2 md2 sm6 xs11 pa-1>
                        <menu-datepicker
                            label="Gerenciados em" :rules="[campoObrigatorio]"
                            outlined dateType="month"
                            v-model="mesRelatorio"
                            display-format="MM/Y"
                            :max-date="maxDate"
                        />
                    </v-flex>
                    <v-flex class="item" lg1 md1 sm6 xs12 pl-4 pt-3>
                        <v-btn id="search" dark rounded color="primary" @click="loadDadosPDF" :loading="loading">
                            <span class="marginSpan"> Gerar PDF </span>
                        </v-btn>
                    </v-flex>
                    <v-flex class="item" lg1 md1 sm6 xs12 pl-1 pt-3>
                        <DialogEmail
                            @inserted="selectEmail" :dialog="dialogEmail" @closeDialog="closeDialogEmail"
                            @openDialog="openEmailInfo"/>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>
    </v-card>
</template>

<script>

import MenuDatepicker from '../../modules/common/components/MenuDatepicker'
import { campoObrigatorio } from '../../filters/rules'
import moment from "moment";
import DialogEmail from '@/components/dialogs/DialogEmail.vue'

export default {
    name: 'RelatorioAnimaisGerenciados',
    components: {
        MenuDatepicker,
        DialogEmail
    },
    data() {
        return {
            mesRelatorio: null,
            loading: false,
            dialogEmail: false
        }
    },
    computed: {
        urlAPI() {
            return this.$store.state.urlAPI
        },
        maxDate() {
            return moment().endOf('month').format('YYYY-MM-DD')
        }
    },
    methods: {
        campoObrigatorio,
        loadDadosPDF () {
            if (this.$refs.form.validate())
            {
                this.loading = true
                this.$axios.get(this.urlAPI + 'relatorio/rag-pdf/', {
                    params: {
                        dt_inicio: moment(this.mesRelatorio, "MM/YYYY").startOf('month').format('YYYY-MM-DD'),
                        dt_fim: moment(this.mesRelatorio, "MM/YYYY").endOf('month').format('YYYY-MM-DD'),
                    }
                })
                .then( response => {
                    window.open(`${this.urlAPI}relatorio-animais-gerenciados-pdf/${response.data.file}/`,   "_blank",
                        "resizable,scrollbars,status");
                })
                .catch((error) => {
                    this.$store.commit('setSnack', {type: 'error', msg : error})
                })
                .finally(() => {
                    this.loading = false;
                })
            }
        },
        closeDialogEmail() {
            this.dialogEmail = false
        },
        openEmailInfo() {
            this.dialogEmail = true
        },
        selectEmail(dsEmail) {
            this.loadDadosExcel(dsEmail)            
        },
        loadDadosExcel (dsEmail) {
            if (this.$refs.form.validate())
            {
                this.loading = true
                this.$axios.get(this.urlAPI + 'relatorio/rag-excel/', {
                    params: {
                        dt_inicio: moment(this.mesRelatorio, "MM/YYYY").startOf('month').format('YYYY-MM-DD'),
                        dt_fim: moment(this.mesRelatorio, "MM/YYYY").endOf('month').format('YYYY-MM-DD'),
                        ds_email: dsEmail
                    }
                })
                .then( response => {
                    this.$store.commit('setSnack', {type: 'success', msg: response.data[0].data})
                    this.closeDialogEmail()
                })
                .catch((error) => {
                    this.$store.commit('setSnack', {type: 'error', msg : error})
                })
                .finally(() => {
                    this.loading = false;
                })
            }
        }
    },
}
</script>